import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../lib/session";
import { joinSociety } from "../lib/api";
import { Field, Notice, PageHead } from "../components/ui";
import Back from "../components/Back";

export default function JoinSociety() {
  const { refresh, chooseSociety } = useSession();
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function go(e) {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const soc = await joinSociety(code);
      // pass the fresh list: the one in state doesn't have this society yet
      const list = await refresh();
      chooseSociety(soc.id, list);
      nav("/");
    } catch (err) {
      setError(err.message ?? String(err));
      setBusy(false);
    }
  }

  return (
    <>
      <Back to="/account">Your account</Back>
      <PageHead title="Join a society"
                sub="You can belong to as many as you like and switch between them." />
      <form onSubmit={go} style={{ maxWidth: 400 }}>
        <Field label="Society code"
               hint="Six characters, from whoever runs it.">
          <input className="input code-input" required autoFocus maxLength={8}
                 autoCapitalize="characters" spellCheck="false" value={code}
                 onChange={(e) => setCode(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))}
                 placeholder="W4YF9R" />
        </Field>
        <Notice kind="error">{error}</Notice>
        <button className="btn btn-primary" disabled={busy || code.length < 4}
                style={{ marginTop: ".6rem" }}>
          {busy ? "Joining…" : "Join"}
        </button>
      </form>
    </>
  );
}
